module.exports = __webpack_public_path__ + "static/media/there-is-hope.2832022a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/there-is-hope.jpg
// module id = 784
// module chunks = 0